


// const dReviews = store.getState(dailyReviews.pay);
export const dailyReviews = [
    {
        title: 'Users',
        // 'amount': dReviews.transactions && dReviews.transactions,
        'icon': 'users'
    },
    {
        title: 'Inventory',
        'amount': '12,000', 
        'icon': 'inventory'
    },
    {
        title: 'Queries',
        'amount': '0', 
        'icon': 'query'
    },
    {
        title: 'Units',
        'amount': '11', 
        'icon': 'department'
    },
    {
        title: 'Request',
        'amount': '4', 
        'icon': 'loader'
    },
    {
        title: 'Feedbacks',
        'amount': '0', 
        'icon': 'feedback'
    },
    // {
    //     title: 'Sliders',
    //     'amount': '₦12,000', 
    //     'icon': 'sliders'
    // },
    // {
    //     title: 'payments',
    //     'amount': '₦12,000', 
    //     'icon': 'payments'
    // },
    // {
    //     title: 'Events',
    //     // 'amount': dReviews.transactions && dReviews.transactions,
    //     'icon': 'events'
    // },
    // {
    //     title: 'Gallery',
    //     // 'amount': '₦'+dReviews.salesAmount && dReviews.salesAmount, 
    //     'icon': 'gallery'
    // },
    // {
    //     title: 'Highlights',
    //     'amount': '₦12,000', 
    //     'icon': 'highlights'
    // },
    {
        title: 'Latest Report',
        'message': "We appreciate the innovating initiative you all have brought to Bida.",
        'icon': 'report'
    },
    //  {
    //     title: 'Customer FeedBack/Contact',
    //     'message': "Taste offers premium services. Keep up the good work!",
    //     'icon': 'review'
    // },

];

export const overallReviews = [
    
    {
        title: 'Users',
        'amount': 12,
        icon: 'users' 
    },
    {
        title: 'Total Sales',
        'amount': '₦13,000',
        icon: 'transaction'
    },
    {
        title: 'Total Returned Amount',
        'amount': '₦103,000,000',
        icon: 'sales' 
    },
    {
        title: 'Total Profit',
        'amount': '₦1,200,000', 
        icon: 'profit'
    },
    {
        title: 'Total Store Items',
        'amount': '₦120,000', 
        icon: 'store'
    },
];
